import { apiClient } from './client';
import { MemberListItemDto, MemberDetailDto } from '../types';

export interface MemberListParams {
  search?: string;
  brgIds?: string[];
}

export const membersApi = {
  list(params?: MemberListParams): Promise<MemberListItemDto[]> {
    const qs = new URLSearchParams();
    if (params?.search) qs.set('search', params.search);
    if (params?.brgIds && params.brgIds.length > 0) {
      params.brgIds.forEach((id) => qs.append('brgId', id));
    }
    const query = qs.toString();
    return apiClient.get<MemberListItemDto[]>(`/api/members${query ? `?${query}` : ''}`);
  },

  getById(userId: string): Promise<MemberDetailDto> {
    return apiClient.get<MemberDetailDto>(`/api/members/${userId}`);
  },
};
